/* Cart-Drawer: Abo-Umschalter + Abo-Anzahl fuer Produkte mit Selling Plans.
   Laeuft komplett ueber Event-Delegation, ueberlebt also das Neurendern
   des Drawers durch das Theme (getCart/api-cart-items). */
(function () {
  if (window.mp2CartSub) return;
  window.mp2CartSub = true;

  var planInterval = function (name) {
    var m = String(name || '').match(/(\d+)\s*monat/i);
    return m ? parseInt(m[1], 10) : 1;
  };

  var refreshCart = function () {
    var items = document.querySelector('cart-items');
    if (items && typeof items.getCart === 'function') {
      items.getCart();
    } else {
      /* Fallback ohne Theme-getCart: Drawer-/Cart-Inhalt selbst neu laden */
      fetch('/cart?section_id=api-cart-items')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var content = tmp.querySelector('[data-api-content]');
          var target = document.querySelector('cart-drawer [data-api-content]') || document.querySelector('[data-api-content]');
          if (content && target) {
            target.replaceWith(content);
          } else if (content) {
            var body = document.querySelector('cart-drawer [data-cart-drawer-body]');
            if (body) {
              body.innerHTML = '';
              body.appendChild(content);
            }
          }
        });
    }
    updateCounts();
  };

  var postJSON = function (url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data),
    }).then(function (r) { return r.json(); });
  };

  /* ==========================================================
     NATIVE FREE-SHIPPING-BAR: Text je nach Cart-Inhalt.
     Abo im Warenkorb  -> Abo-Versand-Text
     Nur Einmalkauf    -> Hinweis auf Abo-Versand-Vorteil
     Sonst             -> Theme-Standard (unberuehrt)
     COPY hier anpassen.
     ========================================================== */
  var MP2_SHIPBAR_ABO = 'Dein Abo wird versandkostenfrei geliefert.';
  var MP2_SHIPBAR_OTP = 'Spare €4,90 Versand — mit Monatlicher Lieferung oder Lieferung alle 3 Monate versandkostenfrei.';
  var MP2_SUB_PRODUCT_IDS = ['11196407284054']; /* Abo-Produkte (weitere IDs ergaenzen) */
  /* Leerer Zustand des Progress-Wheels (Umfang, siehe free-shipping.liquid) */
  var MP2_WHEEL_EMPTY = '87.96459430051421';

  var updateShipBar = function (items) {
    var bars = document.querySelectorAll('[data-free-shipping]');
    if (!bars.length) return;
    var hasAbo = items.some(function (i) { return i.selling_plan_allocation; });
    var hasOtpOnly = false;
    if (!hasAbo) {
      hasOtpOnly = items.some(function (i) {
        return !i.selling_plan_allocation && MP2_SUB_PRODUCT_IDS.indexOf(String(i.product_id)) > -1;
      });
    }
    bars.forEach(function (bar) {
      /* Texte kommen aus dem Theme-Editor (free-shipping Block), Fallback: Konstanten */
      var aboText = bar.getAttribute('data-mp2-abo-message') || MP2_SHIPBAR_ABO;
      var otpText = bar.getAttribute('data-mp2-otp-message') || MP2_SHIPBAR_OTP;
      var pb = bar.querySelector('[data-progress-bar]');
      var pg = bar.querySelector('[data-progress-graph]');
      if (!bar.__mp2orig) {
        var d = bar.querySelector('.free-shipping__default-message');
        var s = bar.querySelector('.free-shipping__success-message');
        bar.__mp2orig = {
          defHTML: d ? d.innerHTML : null,
          defDisplay: d ? d.style.display : null,
          successText: s ? s.textContent : null,
          successDisplay: s ? s.style.display : null,
          successClass: bar.classList.contains('is-success'),
          progressValue: pb ? pb.value : null,
          dashoffset: pg ? pg.style.getPropertyValue('--stroke-dashoffset') : null,
        };
      }
      var o = bar.__mp2orig;
      var def = bar.querySelector('.free-shipping__default-message');
      var suc = bar.querySelector('.free-shipping__success-message');

      if (hasAbo) {
        if (suc) { suc.textContent = aboText; suc.style.display = ''; }
        if (def) def.style.display = 'none';
        bar.classList.add('is-success');
        /* Balken voll: Abo = versandkostenfrei */
        if (pb) pb.value = pb.max || 100;
        if (pg) pg.style.setProperty('--stroke-dashoffset', '0');
      } else if (hasOtpOnly) {
        if (suc) suc.style.display = 'none';
        if (def) { def.textContent = otpText; def.style.display = ''; }
        bar.classList.remove('is-success');
        /* Balken halb voll: Einmalkauf = Versand wird nicht uebernommen */
        if (pb) pb.value = (parseFloat(pb.max) || 100) / 2;
        if (pg) pg.style.setProperty('--stroke-dashoffset', String(parseFloat(MP2_WHEEL_EMPTY) / 2));
      } else {
        /* Theme-Standard wiederherstellen */
        if (def && o.defHTML !== null) { def.innerHTML = o.defHTML; def.style.display = o.defDisplay || ''; }
        if (suc && o.successText !== null) { suc.textContent = o.successText; suc.style.display = o.successDisplay || ''; }
        bar.classList.toggle('is-success', o.successClass);
        if (pb && o.progressValue !== null) pb.value = o.progressValue;
        if (pg && o.dashoffset) pg.style.setProperty('--stroke-dashoffset', o.dashoffset);
      }
    });
  };

  /* Header-/Drawer-Zaehler + Free-Shipping-Bar aktualisieren.
     Verzoegerung, weil das Theme nach getCart() selbst ein Zwischen-Event
     mit cartCount 0 dispacht — unsere Werte muessen danach kommen. */
  var updateCounts = function () {
    setTimeout(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cartCount: c.item_count } }));
          updateShipBar(c.items || []);
        })
        .catch(function () {});
    }, 250);
  };
  window.mp2UpdateCounts = updateCounts;

  updateCounts();

  /* Anzeige pro Abo-Item aktualisieren (Anzahl = Boxen / Intervall) */
  var updateAboLabels = function (root) {
    (root || document).querySelectorAll('[data-mp2-abo-qty]').forEach(function (box) {
      var qty = parseInt(box.getAttribute('data-qty'), 10) || 1;
      var item = box.closest('[data-item]');
      var sel = item ? item.querySelector('[data-mp2-plan-select]') : null;
      var name = sel && sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].textContent : '';
      var interval = sel && sel.value ? planInterval(name) : (parseInt(box.getAttribute('data-interval'), 10) || 1);
      var count = box.querySelector('[data-mp2-abo-count]');
      var unit = box.querySelector('[data-mp2-abo-unit]');
      if (count) count.textContent = String(Math.max(1, Math.round(qty / interval)));
      if (unit) unit.textContent = sel && sel.value ? name : 'Einmalkauf';
    });
  };

  /* Einmalig + nach jedem Re-Render (Drawer UND Cart-Seite) */
  updateAboLabels(document);
  if ('MutationObserver' in window) {
    var t = null;
    var reobserve = function () { updateAboLabels(document); };
    var observer = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(reobserve, 80);
    });
    var drawer = document.querySelector('cart-drawer');
    if (drawer) observer.observe(drawer, { childList: true, subtree: true });
    var pageItems = document.querySelector('cart-items');
    if (pageItems) observer.observe(pageItems, { childList: true, subtree: true });
  }

  /* Plan-Wechsel: neues Line-Item anlegen, altes entfernen */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('[data-mp2-plan-select]') : null;
    if (!sel) return;

    var line = sel.getAttribute('data-line');
    var variantId = sel.getAttribute('data-variant-id');
    var currentQty = parseInt(sel.getAttribute('data-qty'), 10) || 1;
    var oldName = sel.options[sel.selectedIndex] ? '' : '';
    var oldInterval = 1;
    try {
      /* bisheriger Plan-Name steht im vorherigen data-Attribut */
      oldInterval = planInterval(sel.getAttribute('data-current-plan'));
    } catch (err) {}
    var newName = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].textContent : '';
    var aboCount = Math.max(1, Math.round(currentQty / (oldInterval || 1)));
    var newInterval = sel.value ? planInterval(newName) : 1;
    var newQty = aboCount * newInterval;

    var addData = { id: String(variantId), quantity: newQty };
    if (sel.value) addData.selling_plan = String(sel.value);

    sel.disabled = true;
    /* Appstles Bundle-Interceptor wuerde den add-Request auf die
       Bundle-Default-Kombo umschreiben — fuer den Wechsel gezielt
       deaktivieren und danach wieder aktivieren. */
    var variantIdStr = String(variantId);
    try {
      if (typeof window.disableAppstleBundlesInterceptor === 'function') {
        window.disableAppstleBundlesInterceptor({ variantId: variantIdStr });
      }
    } catch (err) {}
    var reenable = function () {
      try {
        if (typeof window.initAppstleBundlesInterceptor === 'function') {
          window.initAppstleBundlesInterceptor({ variantId: variantIdStr });
        }
      } catch (err) {}
    };
    postJSON('/cart/change.js', { id: variantIdStr, quantity: 0 })
      .then(function () { return postJSON('/cart/add.js', addData); })
      .then(function (res) {
        reenable();
        if (res.status) throw new Error(res.message || 'add failed');
        refreshCart();
      })
      .catch(function () {
        reenable();
        sel.disabled = false;
        refreshCart();
      });
  });

  /* Abo-Anzahl: in Schritten von `intervall` Boxen */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-mp2-abo-inc],[data-mp2-abo-dec]') : null;
    if (!btn) return;
    e.preventDefault();

    var box = btn.closest('[data-mp2-abo-qty]');
    if (!box) return;
    var line = btn.getAttribute('data-line') || box.getAttribute('data-line');
    var qty = parseInt(box.getAttribute('data-qty'), 10) || 1;
    var item = box.closest('[data-item]');
    var sel = item ? item.querySelector('[data-mp2-plan-select]') : null;
    var interval = 1;
    if (sel && sel.value && sel.options[sel.selectedIndex]) {
      interval = planInterval(sel.options[sel.selectedIndex].textContent);
    }
    var next = qty + (btn.hasAttribute('data-mp2-abo-inc') ? interval : -interval);
    if (next < interval) next = interval;

    btn.disabled = true;
    postJSON('/cart/change.js', { id: String(box.getAttribute('data-variant-id') || (item && item.querySelector('[data-mp2-plan-select]') ? item.querySelector('[data-mp2-plan-select]').getAttribute('data-variant-id') : '')), quantity: next })
      .then(function () { refreshCart(); })
      .catch(function () { btn.disabled = false; });
  });
})();
